import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
    Box,
    Chip
} from '@mui/material';
import { signOut } from "supertokens-auth-react/recipe/session";
import { useNavigate } from "react-router-dom";

const SubscriptionBlockModal = ({ open, status, tier }) => {


    const navigate = useNavigate();

    const handleActivate = () => {
        navigate("/signup?step=plan");
    };

    const handleLogout = async () => {
        await signOut();
        window.location.href = "/auth";
    };

    return (
        <Dialog
            open={open}
            aria-labelledby="subscription-alert-dialog-title"
            aria-describedby="subscription-alert-dialog-description"
            disableEscapeKeyDown
        >

            <DialogTitle id="subscription-alert-dialog-title">
                {"Subscription Required"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="subscription-alert-dialog-description">
                    Your account subscription is inactive or incomplete.
                    Please subscribe to a plan to access Assignify.
                </DialogContentText>
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography variant="body2" color="textSecondary">
                            Status:
                        </Typography>
                        <Chip
                            label={status || "Unknown"}
                            color={['active', 'trialing'].includes(status) ? "success" : "error"}
                            variant="outlined"
                            size="small"
                        />
                    </Box>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleLogout} color="inherit">
                    Logout
                </Button>
                <Button onClick={handleActivate} variant="contained" color="primary" autoFocus>
                    Subscribe
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SubscriptionBlockModal;
